import { render } from "./eFooter.vue?vue&type=template&id=06e2fbf1&scoped=true&ts=true"
import script from "./eFooter.vue?vue&type=script&lang=ts"
export * from "./eFooter.vue?vue&type=script&lang=ts"

import "./eFooter.vue?vue&type=style&index=0&id=06e2fbf1&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e2fbf1"]])

export default __exports__